import { Component } from '@angular/core';
import { CreatePasswordMode, CreatePasswordFormComponent } from '../../components/create-password-form/create-password-form.component';

@Component({
    selector: 'app-confirm-password-reset',
    templateUrl: './confirm-password-reset.component.html',
    styleUrls: ['./confirm-password-reset.component.scss'],
    imports: [CreatePasswordFormComponent]
})
export class ConfirmPasswordResetComponent {
  createPasswordModes = CreatePasswordMode;

  constructor() {}
}
